import React, { useEffect, useRef } from 'react';
import { View } from 'react-native';
import L from 'leaflet';

let leafletCssInjected = false;

/** Inline CSS (CSP style-src allows unsafe-inline; evita unpkg bloqueado en prod). */
function injectLeafletCss(): void {
  if (leafletCssInjected || typeof document === 'undefined') return;
  leafletCssInjected = true;
  const style = document.createElement('style');
  style.setAttribute('data-vuelto-leaflet', '1');
  style.textContent = `
.leaflet-pane,.leaflet-tile,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-tile-container,
.leaflet-pane>svg,.leaflet-pane>canvas,.leaflet-zoom-box,.leaflet-image-layer,.leaflet-layer{position:absolute;left:0;top:0}
.leaflet-container{overflow:hidden;width:100%;height:100%;outline:0;background:#ddd;touch-action:pan-x pan-y}
.leaflet-tile,.leaflet-marker-icon,.leaflet-marker-shadow{-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-user-drag:none}
.leaflet-tile::selection{background:transparent}
.leaflet-safari .leaflet-tile{image-rendering:-webkit-optimize-contrast}
.leaflet-safari .leaflet-tile-container{width:1600px;height:1600px;-webkit-transform-origin:0 0}
.leaflet-marker-icon,.leaflet-marker-shadow{display:block}
.leaflet-container .leaflet-overlay-pane svg{max-width:none!important;max-height:none!important}
.leaflet-container .leaflet-marker-pane img,.leaflet-container .leaflet-shadow-pane img,
.leaflet-container .leaflet-tile-pane img,.leaflet-container img.leaflet-image-layer,
.leaflet-container .leaflet-tile{max-width:none!important;max-height:none!important;width:auto;padding:0}
.leaflet-container.leaflet-touch-zoom{-ms-touch-action:pan-x pan-y;touch-action:pan-x pan-y}
.leaflet-container.leaflet-touch-drag{-ms-touch-action:pinch-zoom;touch-action:none;touch-action:pinch-zoom}
.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom{-ms-touch-action:none;touch-action:none}
.leaflet-container{-webkit-tap-highlight-color:transparent}
.leaflet-container a{-webkit-tap-highlight-color:rgba(51,181,229,.4)}
.leaflet-tile{filter:inherit;visibility:hidden}
.leaflet-tile-loaded{visibility:inherit}
.leaflet-zoom-box{width:0;height:0;box-sizing:border-box;z-index:800}
.leaflet-overlay-pane svg{-moz-user-select:none}
.leaflet-pane{z-index:400}
.leaflet-tile-pane{z-index:200}
.leaflet-overlay-pane{z-index:400}
.leaflet-shadow-pane{z-index:500}
.leaflet-marker-pane{z-index:600}
.leaflet-tooltip-pane{z-index:650}
.leaflet-popup-pane{z-index:700}
.leaflet-map-pane canvas{z-index:100}
.leaflet-map-pane svg{z-index:200}
.leaflet-vml-shape{width:1px;height:1px}
.lvml{behavior:url(#default#VML);display:inline-block;position:absolute}
.leaflet-control{position:relative;z-index:800;pointer-events:visiblePainted;pointer-events:auto}
.leaflet-top,.leaflet-bottom{position:absolute;z-index:1000;pointer-events:none}
.leaflet-top{top:0}
.leaflet-right{right:0}
.leaflet-bottom{bottom:0}
.leaflet-left{left:0}
.leaflet-control{float:left;clear:both}
.leaflet-right .leaflet-control{float:right}
.leaflet-top .leaflet-control{margin-top:10px}
.leaflet-bottom .leaflet-control{margin-bottom:10px}
.leaflet-left .leaflet-control{margin-left:10px}
.leaflet-right .leaflet-control{margin-right:10px}
.leaflet-fade-anim .leaflet-tile{will-change:opacity}
.leaflet-fade-anim .leaflet-popup{opacity:0;transition:opacity .2s linear}
.leaflet-fade-anim .leaflet-map-pane .leaflet-popup{opacity:1}
.leaflet-zoom-animated{transform-origin:0 0}
.leaflet-zoom-anim .leaflet-zoom-animated{will-change:transform}
.leaflet-zoom-anim .leaflet-zoom-animated{transition:transform .25s cubic-bezier(0,0,.25,1)}
.leaflet-zoom-anim .leaflet-tile,.leaflet-pan-anim .leaflet-tile{-webkit-transition:none;transition:none}
.leaflet-zoom-anim .leaflet-zoom-hide{visibility:hidden}
.leaflet-interactive{cursor:pointer}
.leaflet-grab{cursor:-webkit-grab;cursor:-moz-grab;cursor:grab}
.leaflet-crosshair,.leaflet-crosshair .leaflet-interactive{cursor:crosshair}
.leaflet-popup-pane,.leaflet-control{cursor:auto}
.leaflet-dragging .leaflet-grab,.leaflet-dragging .leaflet-grab .leaflet-interactive,
.leaflet-dragging .leaflet-marker-draggable{cursor:move;cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}
.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-image-layer,.leaflet-pane>svg path,
.leaflet-tile-container{pointer-events:none}
.leaflet-marker-icon.leaflet-interactive,.leaflet-image-layer.leaflet-interactive,
.leaflet-pane>svg path.leaflet-interactive,svg.leaflet-image-layer.leaflet-interactive path{pointer-events:visiblePainted;pointer-events:auto}
.leaflet-container{background:#ddd;outline-offset:1px}
.leaflet-container a{color:#0078a8}
.leaflet-container a.leaflet-active{outline:2px solid orange}
.leaflet-zoom-box{border:2px dotted #38f;background:rgba(255,255,255,.5)}
.leaflet-bar{box-shadow:0 1px 5px rgba(0,0,0,.65);border-radius:4px}
.leaflet-bar a{background-color:#fff;border-bottom:1px solid #ccc;width:26px;height:26px;line-height:26px;
  display:block;text-align:center;text-decoration:none;color:#000}
.leaflet-bar a,.leaflet-control-layers-toggle{background-position:50% 50%;background-repeat:no-repeat;display:block}
.leaflet-bar a:hover,.leaflet-bar a:focus{background-color:#f4f4f4}
.leaflet-bar a:first-child{border-top-left-radius:4px;border-top-right-radius:4px}
.leaflet-bar a:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-bottom:none}
.leaflet-bar a.leaflet-disabled{cursor:default;background-color:#f4f4f4;color:#bbb}
.leaflet-touch .leaflet-bar a{width:30px;height:30px;line-height:30px}
.leaflet-touch .leaflet-bar a:first-child{border-top-left-radius:2px;border-top-right-radius:2px}
.leaflet-touch .leaflet-bar a:last-child{border-bottom-left-radius:2px;border-bottom-right-radius:2px}
.leaflet-control-zoom-in,.leaflet-control-zoom-out{font:bold 18px 'Lucida Console',Monaco,monospace;text-indent:1px}
.leaflet-touch .leaflet-control-zoom-in,.leaflet-touch .leaflet-control-zoom-out{font-size:22px}
.leaflet-control-attribution{background:#fff;background:rgba(255,255,255,.8);margin:0;padding:0 5px;color:#333;font:11px/1.5 Arial,Helvetica,sans-serif}
.leaflet-control-attribution a{text-decoration:none}
.leaflet-control-attribution a:hover,.leaflet-control-attribution a:focus{text-decoration:underline}
.leaflet-container .leaflet-control-attribution,.leaflet-container .leaflet-control-scale{font-size:11px}
.leaflet-left .leaflet-control-scale{margin-left:5px}
.leaflet-bottom .leaflet-control-scale{margin-bottom:5px}
.vuelto-map-pin{width:28px;height:28px;margin-left:-14px;margin-top:-28px;background:#0d9488;border:2px solid #fff;
  border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 2px 6px rgba(0,0,0,.35)}
.vuelto-map-pin::after{content:'';position:absolute;left:50%;top:50%;width:8px;height:8px;margin:-4px 0 0 -4px;
  background:#fff;border-radius:50%}
`;
  document.head.appendChild(style);
}

function pinIcon() {
  return L.divIcon({
    className: '',
    html: '<div class="vuelto-map-pin"></div>',
    iconSize: [28, 28],
    iconAnchor: [14, 28],
  });
}

type MapViewProps = {
  initialRegion?: { latitude: number; longitude: number; latitudeDelta: number; longitudeDelta: number };
  region?: { latitude: number; longitude: number; latitudeDelta: number; longitudeDelta: number };
  style?: any;
  showsUserLocation?: boolean;
  children?: React.ReactNode;
};

type MarkerProps = {
  coordinate: { latitude: number; longitude: number };
  draggable?: boolean;
  onDragEnd?: (e: { nativeEvent: { coordinate: { latitude: number; longitude: number } } }) => void;
  title?: string;
};

type CircleProps = {
  center: { latitude: number; longitude: number };
  radius: number;
  strokeColor?: string;
  fillColor?: string;
};

type PolygonProps = {
  coordinates: { latitude: number; longitude: number }[];
  strokeColor?: string;
  fillColor?: string;
};

const MapContext = React.createContext<{ map: L.Map; layerGroup: L.LayerGroup } | null>(null);

export const MapView = React.forwardRef<any, MapViewProps>((props, ref) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<L.Map | null>(null);
  const layerRef = useRef<L.LayerGroup | null>(null);
  const [ready, setReady] = React.useState(false);

  useEffect(() => {
    let cancelled = false;
    let resizeTimer: ReturnType<typeof setTimeout> | undefined;

    injectLeafletCss();
    if (!containerRef.current || cancelled) return;

    const region = props.initialRegion || props.region;
    const lat = region?.latitude ?? -34.6037;
    const lng = region?.longitude ?? -58.3816;

    const map = L.map(containerRef.current, {
      zoomControl: true,
      attributionControl: true,
    }).setView([lat, lng], 15);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap',
      maxZoom: 19,
    }).addTo(map);

    const layerGroup = L.layerGroup().addTo(map);
    mapRef.current = map;
    layerRef.current = layerGroup;
    setReady(true);

    // Contenedor a veces aún no tiene layout en mobile/PWA → tiles en blanco.
    const invalidate = () => {
      map.invalidateSize();
    };
    resizeTimer = setTimeout(invalidate, 50);
    requestAnimationFrame(invalidate);

    return () => {
      cancelled = true;
      if (resizeTimer) clearTimeout(resizeTimer);
      map.remove();
      mapRef.current = null;
      layerRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount once like native MapView
  }, []);

  useEffect(() => {
    if (mapRef.current && props.region) {
      mapRef.current.setView(
        [props.region.latitude, props.region.longitude],
        mapRef.current.getZoom() || 15,
      );
    }
  }, [props.region?.latitude, props.region?.longitude]);

  React.useImperativeHandle(ref, () => ({
    map: mapRef.current,
    layerGroup: layerRef.current,
    animateToRegion: (
      region: { latitude: number; longitude: number },
      _duration?: number,
    ) => {
      if (!mapRef.current) return;
      mapRef.current.setView([region.latitude, region.longitude], 16);
    },
  }));

  const height = props.style?.height ?? 200;
  const width = props.style?.width ?? '100%';

  return React.createElement(
    View,
    { style: { width, height, overflow: 'hidden', borderRadius: 12 } },
    React.createElement('div', {
      ref: containerRef,
      style: { width: '100%', height: '100%' },
    }),
    ready &&
      mapRef.current &&
      layerRef.current &&
      React.createElement(
        MapContext.Provider,
        { value: { map: mapRef.current, layerGroup: layerRef.current } },
        props.children,
      ),
  );
});

export const Marker = (props: MarkerProps) => {
  const ctx = React.useContext(MapContext);
  const markerRef = useRef<L.Marker | null>(null);

  useEffect(() => {
    if (!ctx?.layerGroup) return;
    if (markerRef.current) {
      ctx.layerGroup.removeLayer(markerRef.current);
    }
    markerRef.current = L.marker([props.coordinate.latitude, props.coordinate.longitude], {
      draggable: props.draggable ?? false,
      icon: pinIcon(),
    }).addTo(ctx.layerGroup);

    if (props.draggable && props.onDragEnd) {
      markerRef.current.on('dragend', () => {
        const ll = markerRef.current!.getLatLng();
        props.onDragEnd?.({
          nativeEvent: {
            coordinate: { latitude: ll.lat, longitude: ll.lng },
          },
        });
      });
    }

    return () => {
      if (markerRef.current && ctx?.layerGroup) {
        ctx.layerGroup.removeLayer(markerRef.current);
      }
    };
  }, [ctx?.layerGroup, props.coordinate.latitude, props.coordinate.longitude, props.draggable]);

  return null;
};

export const Circle = (props: CircleProps) => {
  const ctx = React.useContext(MapContext);
  const circleRef = useRef<L.Circle | null>(null);

  useEffect(() => {
    if (!ctx?.layerGroup) return;
    if (circleRef.current) {
      ctx.layerGroup.removeLayer(circleRef.current);
    }
    circleRef.current = L.circle([props.center.latitude, props.center.longitude], {
      radius: props.radius,
      color: props.strokeColor ?? '#3388ff',
      fillColor: props.fillColor ?? '#3388ff33',
      fillOpacity: 0.2,
    }).addTo(ctx.layerGroup);

    return () => {
      if (circleRef.current && ctx?.layerGroup) {
        ctx.layerGroup.removeLayer(circleRef.current);
      }
    };
  }, [ctx?.layerGroup, props.center.latitude, props.center.longitude, props.radius]);

  return null;
};

export const Polygon = (props: PolygonProps) => {
  const ctx = React.useContext(MapContext);
  const polyRef = useRef<L.Polygon | null>(null);

  useEffect(() => {
    if (!ctx?.layerGroup) return;
    if (polyRef.current) {
      ctx.layerGroup.removeLayer(polyRef.current);
    }
    const latlngs = props.coordinates.map((c) => [c.latitude, c.longitude] as [number, number]);
    polyRef.current = L.polygon(latlngs, {
      color: props.strokeColor ?? '#3388ff',
      fillColor: props.fillColor ?? '#3388ff33',
      fillOpacity: 0.2,
    }).addTo(ctx.layerGroup);

    return () => {
      if (polyRef.current && ctx?.layerGroup) {
        ctx.layerGroup.removeLayer(polyRef.current);
      }
    };
  }, [ctx?.layerGroup]);

  return null;
};

export const Polyline = (_props: any) => null;
export const Heatmap = (_props: any) => null;
export const Overlay = (_props: any) => null;
export const UrlTile = (_props: any) => null;
export const WMSTile = (_props: any) => null;
export const LocalTile = (_props: any) => null;
export const AnimatedRegion = class {
  constructor() {}
};
export const enableLatestRenderer = () => {};
export const PROVIDER_DEFAULT = 'default';
export const PROVIDER_GOOGLE = 'google';
export default MapView;
